<!-- =========================================================================================
  File Name: profile.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="page-user-view">
    <invite-camuser-sidebar :isCamUserSidebarActive="addNewCamUserSidebar" @getdata="getdata" @closeCamUserSidebar="toggleCamUserSidebar" :data="camUserSidebarData" />
    <data-view-cam-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <data-view-sidebar :isSidebarActive="addNewStudentSidebar" @getdata="getdata" @closeSidebar="toggleStudnetSidebar" :data="studentSidebarData" />
    <data-view-camera-sidebar :isSidebarActive="addNewCameraSidebar" @getdata="getdata" @closeSidebar="toggleCameraSidebar" :data="cameraSidebarData" />
    <data-view-sibling-sidebar :isSidebarActive="addNewSiblingSidebar"  @getsiblingdata="getsiblingdata" @closeSidebar="toggleSiblingSidebar" :data="siblingSidebarData" />
    <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @getdata="getdata"  @closeSidebar="toggleScheduleSidebar" :data="scheduleData" />
    <student-setting-sidebar :isSettingSidebarActive="addSettingSidebar" @getdata="getdata" @closeSidebar="toggleSettingSidebar" :data="sidebarSettingData" />

    <vs-alert color="danger" title="User not found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
      </span>
    </vs-alert>
    <div id="user-data" v-if="student">
      <vx-card v-disable-all="!student.location.billing">
      <span v-if="lng!='dogs'">
      <h4  v-if="student.middle_name" class="mb-base">{{student.fname+' '+student.middle_name+' '+student.lname}}</h4>
      <h4  v-else class="mb-base">{{student.fname+' '+student.lname}}</h4>
      </span>
      <span v-else>
       <h4  class="mb-base">{{student.fname}}</h4>
      </span>

        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-2" v-if="student.image">
              <img loading="lazy" :src="img_cdn+student.image" class="rounded w-full" @click.stop="editStudentData(student)"/>
            </div>
             <div class="img-container mb-2" v-else>
              <p class="rounded w-full bg-primary text-white" @click.stop="editStudentData(student)" :data-letters="student.fname[0].toUpperCase()"></p>
            </div>
          </div>
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td v-if="lng!='dogs'" class="font-semibold">First Name</td>
                <td v-else class="font-semibold">Name</td>
                <td>{{ student.fname}}</td>
              </tr>
               <tr  v-if="lng!='dogs'">
                <td class="font-semibold">Middle Name</td>
                <td v-if="student.middle_name">{{ student.middle_name}}</td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-semibold">Status</td>
                <td v-if="student.status">Enabled</td>
                <td v-else>Disabled</td>
              </tr>
              <tr>
                <td class="font-semibold">Program</td>
                <td><vs-chip v-if="student.program.color_code" class="product-order-status text-white" :style="{background: student.program.color_code}" >{{student.program.name}}</vs-chip>
                 <vs-chip v-else class="product-order-status" >{{student.program.name}}</vs-chip>
                </td>
              </tr>
              <!-- <tr>
                <td class="font-semibold">Last Updated By</td>
                <td>{{ student.updatedby }}</td>
              </tr> -->
               <tr>
              <td class="font-semibold">Cameras</td>
              <td v-if="student.cameras.length===0">No Camera</td>
              <td v-if="student.cameras.length>0">
              <div  v-for="(camera, index) in student.cameras" :key="index">
              <vs-chip @click="removeCamera(camera.id)"  closable color="primary" close-icon="close">
              <vs-avatar icon-pack="feather" icon="icon-camera" :color="camera.color_code" />
              {{camera.name}} -  {{camera.code}}
              </vs-chip>
              </div></td>
              </tr>
              <tr>
                <td></td>
                <td>
               <vs-button @click.native="addNewCamera(student)" size="small">
                 <!-- <feather-icon icon="PlusIcon" svgClasses="h-2 w-2" /> -->
               <span>Assign Camera</span></vs-button>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Schedule</td>
                <td  v-if="student.schedule">
                   <!-- <p class="font-semibold">{{student.schedule.name}}</p> -->
                   <span v-for="scheduledate in student.schedule.scheduledates" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatTime }}   {{ scheduledate.end_time | formatTime }}
                </span>
                <br>
              </span>
              </td>
              <td v-else>No Schedule</td>
              </tr>
               <tr>
                <td></td>
                <td>
               <vs-button @click.native="addSchedule(student)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New</span></vs-button>
               <vs-button v-if="student.schedule" class="ml-1" @click.native="confirmDeleteSchedule(student)" color="danger" size="small">
               <span>Remove</span></vs-button>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Created By </td>
                <span>
                <td v-if="added_by" > {{ added_by }}</td>
                 <td v-else> N/A</td>
                </span>
              </tr>
              <tr>
                <td class="font-semibold">Created At </td>
                <span>
                <td v-if="student.created_at"> {{ student.created_at | formatDates}}</td>
                 <td v-else> N/A</td>
                </span>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr v-if="lng!='dogs'">
                <td class="font-semibold">Last Name</td>
                <td>{{ student.lname }}</td>
              </tr>
              <tr v-if="lng!='dogs'">
                <td class="font-semibold">Nickname</td>
                <td v-if="student.nick_name">{{ student.nick_name }}</td>
                <td v-else>N/A</td>
              </tr>

                <tr>
                <td class="font-semibold">Location</td>
                 <td>{{ student.location.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Birthday</td>
                <td v-if="student.dob">{{ student.dob | formatDate}} ({{calculateAge(student.dob)}})</td>
                <td v-else>N/A</td>
              </tr>

              <tr>
              <td class="font-semibold">Siblings</td>
              <td  v-if="Sibling && Sibling.length > 0">
              <div  v-for="(sibling, index) in Sibling" :key="index">
              <vs-chip @click="removeSibling(sibling.id)" closable color="primary" close-icon="close">
              <vs-avatar v-if="sibling.image" :src="img_cdn+sibling.image"  @click="profile(sibling.id)"/>
              <vs-avatar v-else @click="profile(sibling.id)"/>
              <p  v-if="lng!='dogs'" class="text-inherit cursor-pointer" @click="profile(sibling.id)"> {{ sibling.fname }} {{ sibling.lname }}</p>
              <p  v-else  class="text-inherit cursor-pointer" @click="profile(sibling.id)"> {{ sibling.fname }}</p>
               </vs-chip>
              </div></td>
              <td v-else>No Sibling</td>
              </tr>

               <tr>
                <td></td>
                <td>
               <vs-button @click.native="addNewSibling(student)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New</span></vs-button>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Updated By </td>
                <span>
                <td v-if="update_by" > {{ update_by }}</td>
                 <td v-else> N/A</td>
                </span>
              </tr>
                 <tr>
                <td class="font-semibold">Updated At </td>
                <span>
                <td  v-if="student.updated_at"> {{ student.updated_at | formatDates}}</td>
                <td v-else> N/A</td>
                </span>
              </tr>

            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click.native="editStudentData(student)">Edit</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click.native="confirmDeleteRecord(student)">Delete</vs-button>
              <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer" v-if="student.location.billing" >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                <vs-dropdown-item @click="settingData(student)">
                <span class="flex items-center" >
                  <feather-icon icon="SettingsIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.settting') }}s</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="MessagePopupAction(student.id)">
                <span class="flex items-center" >
                  <feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Messages</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
          </div>
        </div>
      </vx-card>
    </div>
    <div id="demo-basic-card" v-if="student.users" v-disable-all="!student.location.billing">
       <div class="flex flex-wrap-reverse items-center data-list-btn-container">
       <h3 class="ml-5">{{ $t('student.users.heading') }}</h3>
          <!-- ADD NEW -->
          <vs-button  class="p-3 ml-2 mr-4"  @click.native="addNewCamUser(student)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>
          <!-- <div class="btn-add-new p-3 ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewCamUser(student)">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>

          </div> -->
        </div>
      <p v-if="student.users.length===0" class="ml-5 text-left mt-5">No {{ $t('user.titlesmall') }} has access to this {{ $t('student.titlesmall') }}</p>
      <div class="vx-row mt-5" v-if="student.users.length>0 && Sibling.length>0" >
            <!-- USER PROFILE CARD 2 - MINIMAL -->
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(camuser, index) in student.users" :key="index">
              <vx-card :class="checkBlackList(camuser.pivot.black_list,'class')">
                <vs-row >
                 <vs-col>
                   <div class="con-vs-chip ml-auto  con-color bg-black" v-if="camuser.pivot.black_list">
                     <span class="text-chip vs-chip--text text-white">Banned</span>
                   </div>
                 <vs-tooltip :text="checkBlackList(camuser.pivot.black_list,'tooltip')" position="left" class="float-right">
                      <feather-icon v-if="camuser.pivot.black_list" @click="actionBlackList(false,index)" icon="RotateCwIcon"  style="cursor:pointer" class="inline-flex text-success" svgClasses="h-6 w-6"/>
                      <feather-icon v-else icon="SlashIcon" @click="actionBlackList(true,index)" style="cursor:pointer" class="inline-flex text-danger" svgClasses="h-6 w-6"/>
                   </vs-tooltip>
                 </vs-col>
                </vs-row>
                <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/'+ camuser.id}" class="text-inherit">
                  <vs-avatar v-if="camuser.avatar" class="mx-auto mb-6 block coverimg" size="80px" :src="img_cdn+camuser.avatar" />
                  <p v-else class="bg-primary studentuserdot text-white mx-auto mb-6 block" :data-lettersuser="camuser.fname[0].toUpperCase()"></p>
                </router-link>
                <div class="vx-row">
                  <div class="vx-col">
                    <div class="text-center" >
                      <!-- <span class="flex flex justify-between flex-wrap"> -->
                      <h4 class="text-left trucate">{{ camuser.fname }} {{ camuser.middle_name }} {{ camuser.lname }}</h4>
                      <p class="text-grey text-left trucate"><a :href="`mailto:${camuser.email}`" @click.stop="">{{ camuser.email | valid_email }}</a></p>
                    </div>
                  </div>
                </div>
                  <div class="vx-row">
                  <div  class="vx-col">
                    <!-- <span class="flex flex justify-between flex-wrap">
                      <p class="text-grey" >Alert</p>
                       <vs-switch  v-model="camuser.pivot.alert"></vs-switch>
                    </span> -->
                     <div class="flex justify-between flex-wrap" >
                        <span class="mr-2">
                        </span>
                      <span >
<!--                          <p class="text-grey" v-if="camuser.status">Enabled</p>-->
                          <p class="text-grey" >Receive Alerts</p>
                         <vs-switch  v-if="!camuser.pivot.black_list"  @input="UpdateAlert(student.id,camuser)" v-model="camuser.pivot.alert" ></vs-switch>
                         <vs-switch v-else disabled="true" />
                        </span>
                    </div>

                  </div>
                  <div class="vx-col flex-1">
                    <div class="flex justify-between flex-wrap float-right" v-if="camuser.invited">
                      <i class="mr-2 mt-2">Invited</i>
                      <span v-if="!camuser.pivot.black_list">
                        <vs-tooltip position="top" text="Resend Invite">
                               <feather-icon style="cursor: pointer" icon="MailIcon" svgClasses="h-5 w-5" class=" mt-2"
                                             @click="SendEmail(camuser.email)" v-if="!!validEmail(camuser.email)"/>
                        </vs-tooltip>
                        </span>
                    </div>
                     <div class="flex float-right" v-else-if="camuser.pending">
                          <i class="mr-2">Pending</i>
                            <vs-tooltip  :text="'This '+$t('user.titlesmall')+' needs to be approved, before it can login.'" >
                          <feather-icon icon="InfoIcon" svgClasses="w-5 h-5" class="text-danger"  />
                        </vs-tooltip>
                    </div>

                    <div class="flex justify-between flex-wrap" v-else>
                        <span class="mr-2">
                        </span>
                      <span >
<!--                          <p class="text-grey" v-if="camuser.status">Enabled</p>-->
                          <p class="text-grey" >Status</p>
                          <vs-switch  v-if="!camuser.pivot.black_list" @input="UpdateStatus(camuser)" v-model="camuser.status"></vs-switch>
                          <vs-switch v-else disabled="true" />
                        </span>
                    </div>
                  </div>
                </div>


                <div class="flex justify-between flex-wrap">
                  <vs-button class="mt-4 mr-2 shadow-lg" v-if="!camuser.pivot.black_list" @click.native="editData(student,camuser)" type="gradient" color="primary" gradient-color-secondary="#CE9FFC">Edit</vs-button>
                  <!-- <vs-button v-else  disabled="disabled" type="filled"  class="mt-4 mr-2">Edit</vs-button> -->
                  <button style="cursor: auto;" v-else type="button" name="button" class="vs-component vs-button mt-4 mr-2 vs-button-light vs-button-border" tabindex="1" disabled="disabled"><span class="vs-button-backgroundx vs-button--background" style="opacity: 0; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><!----><span class="vs-button-text vs-button--text">Edit</span><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button>
                  <vs-button class="mt-4" type="border" v-if="!camuser.pivot.black_list" @click.native="removeCamuser(camuser.id)" color="#b9b9b9">Detach</vs-button>
                  <vs-button class="mt-4 " type="filled" v-else @click.native="removeCamuser(camuser.id)"   color="danger">Detach</vs-button>

                </div>

                <template slot="footer">
                  <vs-divider />
                  <div class="flex justify-between flex-wrap">
                        <span>
                            <p class="trucate">
                              <a v-if="camuser.phone" :href="`tel:${camuser.phone}`" @click.stop="">{{ camuser.phone }}</a>
                              <a v-else class="text-inherit">N/A</a>
                            </p>
                            <p class="text-grey">Phone</p>
                        </span>
                    <span>
                          <vs-switch v-if="!camuser.pivot.black_list" @input="Econatact(camuser)" v-model="camuser.pivot.emergency_contact"></vs-switch>
                          <vs-switch v-else disabled="true" />
                            <p class="text-grey">Emergency Contact</p>
                        </span>
                  </div>
                </template>
              </vx-card>
            </div>
        </div>
         <div class="vx-row mt-5" v-else >
            <!-- USER PROFILE CARD 2 - MINIMAL -->
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(camuser, index) in student.users" :key="index">
              <vx-card >
                <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/'+ camuser.id}" class="text-inherit">
                  <vs-avatar v-if="camuser.avatar" class="mx-auto mb-6 block" size="80px" :src="img_cdn+camuser.avatar" />
                  <p v-else class="bg-primary studentuserdot text-white mx-auto mb-6 block" :data-lettersuser="camuser.fname[0].toUpperCase()"></p></router-link>
                <div class="vx-row">
                  <div class="vx-col">
                    <div class="text-center" >
                      <!-- <span class="flex flex justify-between flex-wrap"> -->
                      <h4 class="text-left trucate">{{ camuser.fname }} {{ camuser.middle_name }} {{ camuser.lname }}</h4>
                      <p class="text-grey text-left trucate"><a :href="`mailto:${camuser.email}`" @click.stop="">{{ camuser.email | valid_email }}</a></p>
                    </div>
                  </div>
                </div>
                  <div class="vx-row">
                  <div  class="vx-col">
                    <!-- <span class="flex flex justify-between flex-wrap">
                      <p class="text-grey" >Alert</p>
                       <vs-switch  v-model="camuser.pivot.alert"></vs-switch>
                    </span> -->
                     <div class="flex justify-between flex-wrap" >
                        <span class="mr-2">
                        </span>
                      <span>
<!--                          <p class="text-grey" v-if="camuser.status">Enabled</p>-->
                          <p class="text-grey" >Receive Alerts</p>
                         <vs-switch  @input="UpdateAlert(student.id,camuser)" v-model="camuser.pivot.alert"></vs-switch>
                        </span>
                    </div>

                  </div>
                  <div class="vx-col flex-1">
                    <div class="flex justify-between flex-wrap float-right" v-if="camuser.invited">
                      <i class="mr-2 mt-2">Invited</i>
                      <span>
                        <vs-tooltip position="top" text="Resend Invite">
                               <feather-icon style="cursor: pointer" icon="MailIcon" svgClasses="h-5 w-5" class=" mt-2"
                                             @click="SendEmail(camuser.email)" v-if="!!validEmail(camuser.email)"/>
                        </vs-tooltip>
                        </span>
                    </div>
                    <div class="flex float-right" v-else-if="camuser.pending">
                          <i class="mr-2">Pending</i>
                            <vs-tooltip  :text="'This '+$t('user.titlesmall')+' needs to be approved, before it can login.'" >
                          <feather-icon icon="InfoIcon" svgClasses="w-5 h-5" class="text-danger"  />
                        </vs-tooltip>
                    </div>

                    <div class="flex justify-between flex-wrap" v-else>
                        <span class="mr-2">
                        </span>
                      <span>
<!--                          <p class="text-grey" v-if="camuser.status">Enabled</p>-->
                          <p class="text-grey" >Status</p>
                         <vs-switch  @input="UpdateStatus(camuser)" v-model="camuser.status"></vs-switch>
                        </span>
                    </div>
                  </div>
                </div>


                <div class="flex justify-between flex-wrap">
                  <vs-button class="mt-4 mr-2 shadow-lg" @click.native="editData(student,camuser)" type="gradient" color="primary" gradient-color-secondary="#CE9FFC">Edit</vs-button>
                  <vs-button class="mt-4" type="border" @click.native="removeCamuser(camuser.id)" color="#b9b9b9">Detach</vs-button>
                </div>

                <template slot="footer">
                  <vs-divider />
                  <div class="flex justify-between flex-wrap">
                        <span>
                            <p class="trucate">
                              <a v-if="camuser.phone" :href="`tel:${camuser.phone}`" @click.stop="">{{ camuser.phone }}</a>
                              <a v-else >N/A</a>
                            </p>
                            <p class="text-grey">Phone</p>
                        </span>
                    <span>
                          <vs-switch @input="Econatact(camuser)" v-model="camuser.pivot.emergency_contact"></vs-switch>
                            <p class="text-grey">Emergency Contact</p>
                        </span>
                  </div>
                </template>
              </vx-card>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import DataViewCamSidebar from './DataViewCamSidebar.vue'
import DataViewSidebar from './DataViewSidebar.vue'
import DataViewCameraSidebar from './DataViewCameraSidebar.vue'
import InviteCamUserSidebar from './InviteCamUserSidebar.vue'
import DataViewSiblingSidebar from './DataViewSiblingSidebar.vue'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import StudentSettingSidebar from './StudentSettingSidebar.vue'
import moment from 'moment'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import {
  GET_SIBLING,
  REMOVE_SIBLING,
  REMOVE_STUDENT,
  SINGLE_STUDENT,
  UPDATE_STUDENT,
  UPDATE_STUDENT_USER,
  UPDATE_USER_ACTIVITY,
  UPDATE_USER_TO_SIBLING,
  USER_LOG_DATA,
  REMOVE_STUDENT_SCHEDULE,
  RESEND_INVITED_USER_EMAIL,
  UPDATE_USER_STATUS,
  UPDATE_USER_ALERT,
  UPDATE_STUDENT_CAMERA,
  REMOVE_USER_FROM_STUDENT,
  ACTION_USER_BLACK_LIST
} from '@/graphql'

export default {
  name: 'Student.vue',
  components: {
    DataViewCamSidebar,
    DataViewSidebar,
    DataViewCameraSidebar,
    DataViewSiblingSidebar,
    StatisticsCardLine,
    ScheduleViewSidebar,
    StudentSettingSidebar,
    'InviteCamuserSidebar' : InviteCamUserSidebar
  },
  data: () => ({
    student:'',
    dataCamera:'',
    dataUser:'',
    dataSibling:'',
    user_not_found: false,
    selected: [],
    DeleteID:'',
    name  : '',
    email : '',
    playerOptions: {},
    settings: { // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: .60
    },
    // Data Sidebar
    addNewDataSidebar: false,
    sidebarData: {},
    addNewStudentSidebar: false,
    studentSidebarData : {},
    addNewCameraSidebar: false,
    cameraSidebarData : {},
    addNewCamUserSidebar: false,
    camUserSidebarData : {},
    addNewSiblingSidebar: false,
    siblingSidebarData: {},
    addScheduleSidebar: false,
    scheduleData: {},
    sidebarSettingData: {},
    addSettingSidebar: false,
    itemsPerPage: 4,
    isMounted: false,
    studentlist: '',
    img_cdn:process.env.VUE_APP_AWS_s3Url+"/",    lng: '',
    Sibling: '',
    added_by: null,
    update_by: null
  }),
  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    },
    formatDates (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
      }
    },
    formatTime (value) {
      if (value) {
        return moment(String(value), 'h:mm A').format('h:mm A')
      }
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.$store.state.productsdataList.products
    },
    // student () {
    //  for (var i = 0; i < this.$store.state.dataList.students.length; i++) {
    //     if(this.$store.state.dataList.students[i].id==this.$route.params.userId){
    //       this.siblinglen=this.$store.state.dataList.students[i].siblings.length
    //       this.cameralen=this.$store.state.dataList.students[i].cameras.length
    //       this.camuserlen=this.$store.state.dataList.students[i].camusers.length
    //       return this.$store.state.dataList.students[i]
    //     }
    //   }
    //   return {id: null}
    // },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },
    // cam_users () {
    //   return this.$store.state.dataList.cam_users
    // },
    queriedCamUsers () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.cam_users.length
    }
  },
  methods: {
     MessagePopupAction (id) {
      this.$store.dispatch('setStudent', null)
      this.$store.dispatch('setStudent', id)
      this.$router.push('/alerts')
    },
      settingData (data) {
      this.sidebarSettingData = data

      this.toggleSettingSidebar(true)
    },
     toggleSettingSidebar (val = false) {
      this.addSettingSidebar = val
    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
    SendEmail (email) {
      this.$apollo
        .mutate({
          mutation: RESEND_INVITED_USER_EMAIL,
          variables: {
            email
          }
        })
        .then(response => {
          if (response.data.resendInvitedUserEmail.status == 'SUCCESS') {
            this.EmailStatus()


          } else if (response.data.resendInvitedUserEmail.status == 'ALREADY_APPROVED') {
            this.emailAlreadyApprovedNotification()

          }
        }).catch(error => {
          console.log(error)
        })
    },
    EmailStatus () {
      this.$vs.notify({
        title: 'Email Sent',
        text: 'Email sent sucessfully',
        color: 'success',
        position: 'top-right'
      })
    },
    NotFoundNotification () {
      this.$vs.notify({
        title: 'Not Found',
        text: 'User not found',
        color: 'danger',
        position: 'top-right'
      })
    },
    emailAlreadyApprovedNotification () {
      this.$vs.notify({
        title: 'Already Confirmed',
        text: 'Email Already Confirmed!',
        color: 'danger',
        position: 'top-right'
      })
    },
    calculateAge (dateString) {
      const now = new Date()
      const today = new Date(now.getYear(), now.getMonth(), now.getDate())

      const yearNow = now.getYear()
      const monthNow = now.getMonth()
      const dateNow = now.getDate()

      const dob = new Date(dateString)


      const yearDob = dob.getYear()
      const monthDob = dob.getMonth()
      const dateDob = dob.getDate()
      let age = {}
      let ageString = ''
      let yearString = ''
      let monthString = ''
      let dayString = ''


      let yearAge = yearNow - yearDob

      if (monthNow >= monthDob) var monthAge = monthNow - monthDob
      else {
        yearAge--
        var monthAge = 12 + monthNow - monthDob
      }

      if (dateNow >= dateDob) var dateAge = dateNow - dateDob
      else {
        monthAge--
        var dateAge = 31 + dateNow - dateDob

        if (monthAge < 0) {
          monthAge = 11
          yearAge--
        }
      }

      age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
      }

      if (age.years > 1) yearString = ' years'
      else yearString = ' year'
      if (age.months > 1) monthString = ' months'
      else monthString = ' month'
      if (age.days > 1) dayString = ' days'
      else dayString = ' day'


      if ((age.years > 0) && (age.months > 0) && (age.days > 0)) ageString = `${age.years + yearString  }, ${  age.months  }${monthString}`
      else if ((age.years == 0) && (age.months == 0) && (age.days > 0)) ageString = `Only ${  age.days  }${dayString  } old!`
      else if ((age.years > 0) && (age.months == 0) && (age.days == 0)) ageString = `${age.years + yearString  } old. Happy Birthday!!`
      else if ((age.years > 0) && (age.months > 0) && (age.days == 0)) ageString = `${age.years + yearString  } and ${  age.months  }${monthString}` 
      else if ((age.years == 0) && (age.months > 0) && (age.days > 0)) ageString = `${age.months + monthString  } and ${  age.days  }${dayString}`
      else if ((age.years > 0) && (age.months == 0) && (age.days > 0)) ageString = `${age.years + yearString  } and ${  age.days  }${dayString}` 
      else if ((age.years == 0) && (age.months > 0) && (age.days == 0)) ageString = age.months + monthString 
      else ageString = '0 year'

      return ageString
    },

    removeSchedule () {
      this.$apollo
        .mutate({
          mutation: REMOVE_STUDENT_SCHEDULE,
          variables: {
            id: this.DeleteID.id,
            schedule_id: this.DeleteID.schedule.id
          }
        }).then(response => {
          if (response.data.deleteStudentSchedule.status == 'Success') {
            this.StatusScheduleDeleteSuccess()
            this.get()
          }
        }).catch(error => {
          console.log(error)
        })

    },
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    getsiblingdata (value) {
      if (value) {
        this.getStudentSiblings()
        this.get()
      }
    },
    UpdateSuccess () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Update Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    Econatact (camuser) {
      this.$apollo
        .mutate({
          mutation: UPDATE_STUDENT_USER,
          variables: {
            id :camuser.id,
            fname: camuser.fname,
            middle_name: camuser.middle_name,
            lname: camuser.lname,
            username: camuser.username,
            phone: camuser.phone,
            email: camuser.email,
            invite_email: camuser.invite_email,
            email_confirmed: camuser.email_confirmed,
            status: camuser.status,
            pending:camuser.pending,
            avatar:camuser.avatar,
            emergency_contact:camuser.pivot.emergency_contact,
            student_id:this.student.id
          }
        })
        .then(response => {
          if (response.data.updateStudentUser.status == 'SUCCESS') {
            this.UpdateSuccess()

          }
        }).catch(error => {
          console.log(error)
        })
    },
    UpdateStatus (camuser) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_STATUS,
          variables: {
            id :camuser.id,
            status: camuser.status
          }
        })
        .then(response => {
          if (response.data.updateUserStatus.status == 'SUCCESS') {
            this.UpdateSuccess()

          }
        }).catch(error => {
          console.log(error)
        })
    },
    UpdateAlert (student, camuser) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ALERT,
          variables: {
            id:student,
            user_id :camuser.id,
            alert: camuser.pivot.alert
          }
        })
        .then(response => {
          if (response.data.updateUserAlert.status == 'SUCCESS') {
            this.UpdateSuccess()

          }
        }).catch(error => {
          console.log(error)
        })
    },
    profile (id) {
      if (this.lng != 'dogs') {
        this.$router.replace(`/student/${id}`)
        this.$router.go(`/student/${id}`)
      } else {
        this.$router.replace(`/pet/${id}`)
        this.$router.go(`/pet/${id}`)
      }

    },
    StatusSuccess () {
      this.$vs.notify({
        title:this.$t('student.alert_title'),
        text: `${this.$t('user.alert_title')  } access removed successfully`,
        color: 'success',
        position: 'top-right'
      })
    },
    CameraStatusSuccess () {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Camera deleted successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    SiblingStatusSuccess () {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Sibling detached successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    removeCamuser (id) {
      for (let i = 0; i < this.student.users.length; i++) {
        if (this.student.users[i].id == id) {
          this.student.users.splice(i, 1)
        }
      }
      const getusersids = []
      for (let j = 0; j < this.student.users.length; j++) {
        const getuserid = this.student.users[j].id
        getusersids.push(getuserid)
      }
      this.dataUser = getusersids
       this.$apollo
        .mutate({
          mutation: REMOVE_USER_FROM_STUDENT,
          variables: {
            student:this.student.id,
            users:this.dataUser
          }
        }).then(response => {
          if (response) {
            this.StatusSuccess()
            this.UpdateSibling(this.student.id,this.dataUser)
            this.updateUserActivity(this.student.id)
          }
        }).catch(error => {
          console.log(error)
        })
      // this.$apollo
      //   .mutate({
      //     mutation: UPDATE_STUDENT,
      //     variables: {
      //       id:this.student.id,
      //       users:this.dataUser
      //     }
      //   }).then(response => {
      //     if (response) {
      //       this.StatusSuccess()
      //       this.updateUserActivity(response.updateStudent.id)
      //     }
      //   }).catch(error => {
      //     console.log(error)
      //   })
      
    },

    UpdateSibling(id,users){
     this.$apollo
        .mutate({
          mutation: UPDATE_USER_TO_SIBLING,
          variables: {
            student_id: id,
            users: users
          }
        }).then(response => {
          if (response) {
          // this.StatusSuccess()
          }
        }).catch(error => {
          console.log(error)
        })
    },
    updateUserActivity (id) {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\User',
            activity:'updated'
          }
        })
    },
    removeCamera (id) {
      for (let i = 0; i < this.student.cameras.length; i++) {
        if (this.student.cameras[i].id == id) {
          this.student.cameras.splice(i, 1)
        }
      }
      const getcamerasids = []
      for (let j = 0; j < this.student.cameras.length; j++) {
        const getcameraid = this.student.cameras[j].id
        getcamerasids.push(getcameraid)
      }
      this.dataCamera = getcamerasids
      this.$apollo
        .mutate({
          mutation: UPDATE_STUDENT_CAMERA,
          variables: {
            id:this.student.id,
            cameras:this.dataCamera
          }
        }).then(response => {
          if (response) {
            this.CameraStatusSuccess()
          }
        }).catch(error => {
          console.log(error)
        })
    },
    removeSibling (id) {
      if(id){
      // for (let i = 0; i < this.Sibling.length; i++) {
      //   if (this.Sibling[i].id == id) {
      //     this.Sibling.splice(i, 1)
      //   }
      // }
      this.$apollo
        .mutate({
          mutation: REMOVE_SIBLING,
          variables: {
            student_id:this.$route.params.userId,
            sibling_id:id
          }
        }).then(response => {
          if (response.data.removeSiblings.status==='Success') {
            this.SiblingStatusSuccess()
            this.UpadateUserActivity(this.$route.params.userId)
            this.getStudentSiblings()
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    StatusDeleteSuccess (status, color) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   'Deleted Successfully',
        color:  'success',
        position: 'top-right'
      })
    },
    StatusScheduleDeleteSuccess (status, color) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   'Schedule deleted successfully',
        color:  'success',
        position: 'top-right'
      })
    },
     confirmDeleteSchedule (student) {
      this.DeleteID = student
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Do you really want to remove schedule for this ${this.$t('student.titlesmall')}?`,
        accept: this.removeSchedule,
        acceptText: 'Delete'
      })
    },
    confirmDeleteRecord (student) {
      this.DeleteID = student.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${this.student.fname} ${this.student.lname}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.$router.push({name:'students'})
      this.$apollo
        .mutate({
          mutation: REMOVE_STUDENT,
          variables: {
            id: this.DeleteID
          }
        }).then(response => {
          if (response.data.deleteStudent.status == 'Success') {
            this.StatusDeleteSuccess(response.data.deleteStudent.message, response.data.deleteStudent.color)
            this.$router.push(this.$t('menu.students.url'))
          } else {
            this.StatusDeleteSuccess(response.data.deleteStudent.message, response.data.deleteStudent.color)
          }
        }).catch(error => {
          console.log(error)
        })


      // .then(response => {
      //     this.showDeleteSuccess()
      // }).catch(error => {
      //     console.log(error)
      // });

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: this.$t('student.alert_title'),
        text: 'Deleted Successfully',
        position:'top-right'
      })
    },
    addNewData (data) {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addNewStudent (data) {
      this.studentSidebarData = data
      this.toggleStudnetSidebar(true)
    },
    addNewCamera (data) {
      this.cameraSidebarData = data
      this.toggleCameraSidebar(true)
    },
    addNewSibling (data) {
      data.siblings=this.Sibling
      this.siblingSidebarData = data
      this.toggleSiblingSidebar(true)
    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
    editData (student_data, camuser_data) {
      this.sidebarData = { student : student_data, camuser : camuser_data }
      this.toggleDataSidebar(true)
    },
    editStudentData (data) {
      if(data.location.billing){
      this.studentSidebarData = data
      this.toggleStudnetSidebar(true)
      }
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleStudnetSidebar (val = false) {
      this.addNewStudentSidebar = val
    },
    toggleCameraSidebar (val = false) {
      this.addNewCameraSidebar = val
    },
    toggleSiblingSidebar (val = false) {
      this.addNewSiblingSidebar = val
    },
    toggleCamUserSidebar (val = false) {
      this.addNewCamUserSidebar = val
    },
    toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    getStudentSiblings () {
      this.$apollo
        .mutate({
          mutation: GET_SIBLING,
          variables: {
            id: this.$route.params.userId
          }
        })
        .then(response => {
          if (response) {
            this.Sibling = response.data.getSiblings

          }
        }).catch(error => {
          console.log(error)
        })
    },
    UpadateUserActivity (id) {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type: 'App\\Models\\Student',
            activity: 'updated'
          }
        })
    },
    getUserLogData () {
      this.$apollo
        .mutate({
          mutation: USER_LOG_DATA,
          variables: {
            id: this.$route.params.userId,
            object_type: 'App\\Models\\Student'
          }
        })
        .then(response => {

          for (let i = 0; i < response.data.getUserLogData.data.length; i++) {
            if (response.data.getUserLogData.data[i] && response.data.getUserLogData.data[i].user) {
              if (response.data.getUserLogData.data[i].activity == 'added') {
                this.added_by = `${response.data.getUserLogData.data[i].user.fname  } ${  response.data.getUserLogData.data[i].user.lname}`
              }
                  if (response.data.getUserLogData.data[i].activity == 'updated') {
                    this.update_by = `${response.data.getUserLogData.data[i].user.fname  } ${  response.data.getUserLogData.data[i].user.lname}`
                  }
                }
          }
        })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: SINGLE_STUDENT,
          variables: {
            id: this.$route.params.userId
          }
        })
        .then(response => {
          this.student = response.data.student
          this.getUserLogData()
        }).catch(error => {
          console.log(error)
        })

    },
    checkBlackList(status,type){
      if(type==='tooltip'){
           if(status){
          return 'Unban'
        }else{
             return 'Ban for this student'
        } 
      }
     else
        if(status){
          return 'bg-grey-light'
        }else{
             return 'bg-white'
        }         
    },
    actionBlackList(status,i){
       this.student.users[i].pivot.black_list=status

        this.$apollo
        .mutate({
          mutation: ACTION_USER_BLACK_LIST,
          variables: {
            status: status,
            student_id:this.student.id,
            user_id:this.student.users[i].id
          }
        })
        .then(response => {
          if (response) {
             this.UpdateSuccess()

          }
        }).catch(error => {
          console.log(error)
        })
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
    this.getStudentSiblings()

  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

  #demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
  }
}

#demo-basic-card {
  margin-top: 1.5rem!important;
}
[data-letters]:before {
  content:attr(data-letters);
  display:block;
  border-radius: .25rem !important;
  font-size:100px;
  width: 100% !important;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  height:110px;
  line-height:110px;
  text-align:center;
}
 [data-lettersuser]:before {
  content:attr(data-lettersuser);
   }
  .studentuserdot{
  display:inline-block;
  font-size:50px;
  width:80px;
  height:80px;
  line-height:80px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  margin-left: 100px;
  margin-bottom: 30px;
  }
    // display:inline-block;
  // font-size:50px;
  // width:80px;
  // height:80px;
  // line-height:80px;
  // text-align:center;
  // border-radius:50%;
  // vertical-align:middle;
  // margin-right:1em;
  // margin-left: 100px;
  // margin-bottom: 30px;
</style>
